import { ICON__copy_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';

interface PROPS {}

export function G_BUTTON__fields_store_copy({}: PROPS) {
  const { toast } = useToast();

  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function onClick() {
    let data = generation_current.fields_store.to_object();

    let data_string = JSON.stringify(data);

    await navigator.clipboard.writeText(data_string);

    toast({ title: 'Copied to clipboard' });
  }

  function is_disabled() {
    return generation_current.fields_store.is_empty();
  }

  /*
   * HTML
   */
  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      title={'Copy Fields Store'}
      variant={'no-border-on-bar'}
      Icon={ICON__copy_regular}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      {...{ onClick }}
      className={`w-8 h-5 flex-center ${is_disabled() ? '' : 'opacity-50'}`}
      iconClassNameBase="size-3 text-gray-400"
      iconClassNameHovered="!text-bar-foreground"
    />
  );
}
